/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ProductSummaryResponse,
} from '../models/index';
import {
    ProductSummaryResponseFromJSON,
    ProductSummaryResponseToJSON,
} from '../models/index';

export interface GetProductSummaryByProductNumberRequest {
    productNumber: string;
}

/**
 * 
 */
export class ProductResourceApi extends runtime.BaseAPI {

    /**
     * Creates request options for getProductSummaryByProductNumber without sending the request
     */
    async getProductSummaryByProductNumberRequestOpts(requestParameters: GetProductSummaryByProductNumberRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['productNumber'] == null) {
            throw new runtime.RequiredError(
                'productNumber',
                'Required parameter "productNumber" was null or undefined when calling getProductSummaryByProductNumber().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/v1/ui/product/{productNumber}`;
        urlPath = urlPath.replace(`{${"productNumber"}}`, encodeURIComponent(String(requestParameters['productNumber'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async getProductSummaryByProductNumberRaw(requestParameters: GetProductSummaryByProductNumberRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ProductSummaryResponse>> {
        const requestOptions = await this.getProductSummaryByProductNumberRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ProductSummaryResponseFromJSON(jsonValue));
    }

    /**
     */
    async getProductSummaryByProductNumber(requestParameters: GetProductSummaryByProductNumberRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ProductSummaryResponse> {
        const response = await this.getProductSummaryByProductNumberRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
